module.exports = __webpack_public_path__ + "img/eid-al-fitr2.5d562e19.png";